import React, { useState, useEffect, useRef, useContext } from "react";
import styled from "@emotion/styled";
import Switch from "react-switch";
import { ThemeContext } from "../contexts/ThemeContext";
import { SiTableau, SiPowerbi } from "react-icons/si";
import Tooltip from "@mui/material/Tooltip";
import ForwardRef from "./ForwardRef";

const PlatformSelector = ({ onChange }) => {

    const { theme } = useContext(ThemeContext);

    const [isChecked, setIsChecked] = useState(false);
    const didMount = useRef(false);

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
    }, []);

    const handleChecked = () => {
        const newState = !isChecked;
        setIsChecked(newState);
        onChange(newState);
    }

    const StyledCenterLogo = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        svg {
            width: 60%;
            height: 60%;
        }
    `;

    // Due to the way the Switch component is implemented,
    // we must declare the color codes here, instead of using
    // css variables.
    const lightModeBg = "#dcdbef";
    const darkModeBg = "#305684";

    const lightModeHandleTabLogo = "#fff";
    const darkModeHandleTabLogo = "#fff";

    const lightModeHandlePBILogo = "#000";
    const darkModeHandlePBILogo = "#000";

    const lightModeTabLogo = "#6d6d6d";
    const darkModeTabLogo = "#9b9a9a";

    const lightModePBILogo = "#9b9a9a";
    const darkModePBILogo = "#9b9a9a";

    const selectedBgColor = theme === "dark" ? darkModeBg : lightModeBg;
    const selectedHandleTabLogo = theme === "dark" ? darkModeHandleTabLogo : lightModeHandleTabLogo;
    const selectedHandlePBILogo = theme === "dark" ? darkModeHandlePBILogo : lightModeHandlePBILogo;
    const selectedTabLogo = theme === "dark" ? darkModeTabLogo : lightModeTabLogo;
    const selectedPBILogo = theme === "dark" ? darkModePBILogo : lightModePBILogo;

    return didMount && (
        <Tooltip placement="top" title="Coming soon">
            <ForwardRef>
                <Switch
                    disabled
                    onChange={handleChecked}
                    checked={isChecked}
                    onColor={selectedBgColor}
                    offColor={selectedBgColor}
                    onHandleColor="#eaca0a"
                    offHandleColor="#0068B0"
                    width={81}
                    height={40}
                    handleDiameter={35}
                    uncheckedHandleIcon={(
                        <StyledCenterLogo>
                            <SiTableau width={50} color={selectedHandleTabLogo} />
                        </StyledCenterLogo>
                    )}
                    checkedHandleIcon={(
                        <StyledCenterLogo>
                            <SiPowerbi width={50} color={selectedHandlePBILogo} />
                        </StyledCenterLogo>
                    )}
                    uncheckedIcon={(
                        <StyledCenterLogo>
                            <SiPowerbi color={selectedPBILogo} />
                        </StyledCenterLogo>)}
                    checkedIcon={(
                        <StyledCenterLogo>
                            <SiTableau color={selectedTabLogo} />
                        </StyledCenterLogo>
                    )}
                    activeBoxShadow="0"
                />
            </ForwardRef>
        </Tooltip>
    )
};

export default PlatformSelector;
